import { deleteObject, ref } from 'firebase/storage';
import { storage } from '../firebase/firebase-config';
import {
  attachmentStorageUrls,
  createAttachmentFromFile,
} from '../platform/contentAttachments';
import { uploadFileToStorage } from './storageUpload';

export async function uploadFilesAsAttachments(files, folder, { tenantId, onProgress } = {}) {
  if (!files?.length) {
    return [];
  }

  const attachments = [];

  for (let index = 0; index < files.length; index += 1) {
    const file = files[index];
    const url = await uploadFileToStorage(file, folder, {
      tenantId,
      onProgress: onProgress
        ? (fileProgress) => {
          const overall = ((index + fileProgress / 100) / files.length) * 100;
          onProgress(overall);
        }
        : undefined,
    });
    attachments.push(createAttachmentFromFile(file, url));
  }

  return attachments;
}

export async function deleteStorageUrls(urls = []) {
  const uniqueUrls = [...new Set((urls || []).filter(Boolean))];

  await Promise.all(uniqueUrls.map(async (url) => {
    try {
      await deleteObject(ref(storage, url));
    } catch (error) {
      if (error.code !== 'not-found' && !error.message?.includes('object-not-found')) {
        throw error;
      }
    }
  }));
}

export async function deleteContentAttachmentStorage(item, { extraUrls = [] } = {}) {
  const urls = [
    ...attachmentStorageUrls(item),
    ...extraUrls.filter(Boolean),
  ];
  await deleteStorageUrls(urls);
}
